import {
  addDayOffset,
  getLastDayOfMonth,
  thisMonthDate,
  thisSundayDate,
  todayDate,
} from '../../../common/src/date_string.ts';
import { IntervalType, SongList, SongListType } from '../../../common/src/model.ts';
import { getSongSlug } from '../../../common/src/paths.ts';

export function getDemoSongLists(): SongList[] {
  const today = todayDate();
  const thisMonth = thisMonthDate(today);
  const thisSunday = thisSundayDate(today);
  return [
    {
      date: thisMonth,
      type: SongListType.HymnOfTheMonth,
      interval: { type: IntervalType.Month, start: thisMonth, end: getLastDayOfMonth(thisMonth) },
      songs: [
        { row: 1, slug: getSongSlug({ songNumber: '679', hymnalSlug: 'tr2022' }) }, // A Mighty Fortress Is Our God
      ],
    },
    {
      date: thisSunday,
      type: SongListType.WorshipService,
      songs: [
        { row: 1, slug: getSongSlug({ songNumber: '645', hymnalSlug: 'tr2022' }) }, // How Firm a Foundation
        { row: 2, slug: getSongSlug({ songNumber: '681', hymnalSlug: 'tr2022' }) }, // Come, Thou Fount
        { row: 4, slug: getSongSlug({ songNumber: '1076', hymnalSlug: 'tr2022' }) }, // Doxology
      ],
    },
    {
      date: addDayOffset(thisSunday, 3),
      type: SongListType.Event,
      name: 'Psalm Sing',
      time: '6pm',
      songs: [
        { row: 1, slug: getSongSlug({ songNumber: '75', hymnalSlug: 'tr2022' }) }, // Ps 23: The King of Love My Shepherd Is
        { row: 2, slug: getSongSlug({ songNumber: '16', hymnalSlug: 'tr2022' }) }, // Ps 6: Chide Me, O LORD, No Longer
      ],
    },
  ];
}
